import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const find = require('lodash/find');
const sortBy = require('lodash/sortBy');
const assign = require('lodash/assign');
import { Card, Alert, Button } from 'react-bootstrap';
const _ = {
    map: require('lodash/map'),
    filter: require('lodash/filter'),
    find: require('lodash/find'),
    forEach: require('lodash/forEach'),
};

const RegistrationTokenStore = require('../../stores/registration_token_store');
import LoadingMainContent from '../loading/LoadingMainContent';
import RegTokenProjectListing from './RegTokenProjectListing';
import AdminSiteConfigEditor from './AdminSiteConfigEditor';
import OpenIdProviderSelector from './OpenIdProviderSelector';
import AdminOpenIdProviderEditor from './AdminOpenIdProviderEditor';
import SingleInputModal from '../modal/SingleInputModal';
import LoadingSpinner from '../loading/LoadingSpinner';
import ExpandableWell from '../common/ExpandableWell';
import SortableTableClassic from '../table/SortableTableClassic';
import SiteFeaturesEditor from './SiteFeaturesEditor';
import AdminVoiceEnableDisablePanel from './AdminVoiceEnableDisablePanel';

const OIDCStore = require('../../stores/OIDCStore');
const OIDCActions = require('../../actions/OIDCActions');
const ServerRequest = require('../../actions/request');

const propTypes = {};
const defaultProps = {};

class AdminSiteConfigView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            registrationTokenStoreState: RegistrationTokenStore.getState(),
            openIdProviders: OIDCStore.getState().openIdProviders,
            providerMessageVisible: false,
            providerMessageState: '',
            providerMessage: '',
            haveProviderData: OIDCStore.getState().initialized,
        };

        this.unsubscribes = [
            RegistrationTokenStore.listen(this.onRegistrationTokenStoreStateChange),
            OIDCStore.listen(this.onOIDCStoreChange),
        ];
    }
    
    componentDidMount() {
        OIDCStore.requestDataIfNeeded();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onRegistrationTokenStoreStateChange=(state)=>{
        this.setState({ registrationTokenStoreState: state });
    }
    
    onOIDCStoreChange=(state)=>{
        var changes = {
            openIdProviders: state.openIdProviders,
            haveProviderData: true
        };
        if (state.action && state.action.id === this.state.pendingAddProviderActionId) {
            var op = find(state.openIdProviders,{iss:this.state.pendingIss});
            assign(changes,{
                pendingIss: null,
                pendingAddProviderActionId: null,
                providerMessageVisible: true,
                providerMessage: op ? 'New OpenId Provider added' : 'Error - New OpenId Provider not found',
                providerMessageState: op ? 'success' : 'danger',
                selectedOpId: op ? op.id : null,
            });
        }
        
        this.setState(changes);
    }

    selectOpId=(opId)=>{
        this.setState({ selectedOpId: opId});
    }
    
    closeOpenIdEditor=()=>{
        this.setState({ selectedOpId: null}); // toggle editor off
    }
    
    addOpenIdProvider=()=>{
        if (this.state.addingProvider) {
            return;
        }
        this.setState({
            addingProvider: uuid.v4(),
            selectedOpId: null,
            providerMessageVisible: false
        });
    }
    
    addProviderHandler=(issuer)=>{
        if (!this.state.addingProvider || this.state.pendingAddProviderActionId) {
            return; // bad state
        }
        if (!issuer || find(this.state.openIdProviders,{iss:issuer})) {
            this.setState({
                addingProvider: false,
                providerMessageVisible: true,
                providerMessage: 'issuer must be specified and unique',
                providerMessageState: 'danger' // success
            });
            return;
        }
        
        var actionId = uuid.v4();
        this.setState({
            addingProvider: false,
            pendingAddProviderActionId: actionId,
            pendingIss: issuer,
            providerMessageVisible: true,
            providerMessage: 'adding OpenId Provider',
            providerMessageState: 'info' // success
        });
        OIDCActions.addOpenIdProvider(actionId,{iss: issuer});
    }
    
    renderProviderSection=()=>{
        if (!this.state.haveProviderData) {
            return (
                <Card body bg="light">
                    <h1 className="margin-bottom-lg">Open ID Providers</h1>
                    <LoadingSpinner>Retrieving data...</LoadingSpinner>
                </Card>
            );
        }

        const selectedProvider = find(this.state.openIdProviders, { id: this.state.selectedOpId });
        return (
            <Card body bg="light">
                <h1 className="margin-bottom-lg">Open ID Providers</h1>
                {(this.state.openIdProviders && this.state.openIdProviders.length > 0 ) && 
                    <OpenIdProviderSelector
                        id="admin-add-deployment-op-selector"
                        openIdProviders={this.state.openIdProviders} 
                        labelText="Select OpenID Provider to view/edit"
                        onSelect={(opId)=>{this.selectOpId(opId)}}
                    />
                }
                {(this.state.addingProvider) &&
                    <SingleInputModal
                        show
                        action={this.state.addingProvider}
                        headerText="Enter the URL for the new OpenID Provider"
                        inputLabel="issuer"
                        ariaLabel="issuer"
                        buttonText="add"
                        defaultValue={''}
                        closeHandler={()=>{this.setState({addingProvider: null,addProviderActionId:null});}}
                        submitHandler={this.addProviderHandler}
                    />
                }
                {(this.state.providerMessageVisible) &&
                    <Alert variant={this.state.providerMessageState}>
                        <h4>{this.state.providerMessage}</h4>
                    </Alert>
                }
                {(!!selectedProvider) && <AdminOpenIdProviderEditor op={selectedProvider} closeHandler={this.closeOpenIdEditor}/>}
                <Button onClick={this.addOpenIdProvider}>Add New OpenID Provider</Button>
            </Card>
        );
    }
    
    scanShortCoursesForS3Paths=()=>{
        this.setState({scanning:true},()=>{
            ServerRequest.makeRequest(`/authoring/scan_short_courses_for_hardcoded_asset_paths`, 'GET')
            .then((_results) => {
                let scanResults = _.map(_results.rows,(entry,index)=>{
                    let course = _.find(_results.courseTitles,{id:entry.id});
                    let course_title = course ? course.title : '';
                    let project = _.find(_results.projectNames,{id:Number(entry.project_id)});
                    let project_name = project ? project.name : '';
                    return (
                        {...entry,
                            course_title,
                            project_name,
                            selected: false, // initially unselected
                            index,
                        } 
                    );
                });
                this.setState({scanResults,scanning:false})
            })
            .catch((err) => {
                console.log("scan error:",err);
                this.setState({scanning: false, scanResults: null});
            });
        })
    }
    
    onScanResultsSelect=(index,e)=>{
        let scanResults = this.state.scanResults.slice();
        scanResults[Number(index)].selected = e.target.checked;
        this.setState({scanResults});
    }
    
    selectAllCourseS3PathsToFix=()=>{
        let scanResults = this.state.scanResults.slice();
        _.forEach(scanResults,(entry)=>{
            entry.selected = true;
        });
        this.setState({scanResults});
    }
    
    fixShortCourseS3Paths=()=>{
        var filteredResults = _.filter(this.state.scanResults,{selected:true});
        var scanResults = _.map(filteredResults,(entry)=>({
            column: entry.column,
            project_id: entry.project_id,
            id: entry.id,
            cv_id: entry.cv_id,
            node_id: entry.node_id
        }));
        
        this.setState({scanning:true},()=>{
            ServerRequest.makeRequest(`/authoring/fix_short_courses_for_hardcoded_asset_paths`, 'PATCH', JSON.stringify({ scanResults } ))
            .then((fixResults) => {
                this.setState({scanning:false})
            })
            .catch((err) => {
                console.log("fix error:",err);
                this.setState({scanning: false});
            });
        })
    }
    
    renderScanResults=()=>{
        if (!this.state.scanResults) {
            return null;
        }

        var allCount = this.state.scanResults.length;
        if (!allCount) {
            return (
                <div className="scan-results">
                    <span className="font-style-italic">
                        {'Scan for Hardcoded S3 Paths yielded no results'}
                    </span>
                </div>
            );
        }

        var selectedScanResults = _.filter(this.state.scanResults,{selected:true});
        var selectedCount = selectedScanResults.length;
        var fixText;
        var selectAllButton;
        if (selectedCount === allCount) {
            fixText = "fix all";
        }
        else if (selectedCount) {
            fixText = "fix selected";
            selectAllButton = (
                <Button onClick={this.selectAllCourseS3PathsToFix}>{'Select All'}</Button>
            );
        }
        
        return (
            <div className="scan-results">
                { selectAllButton }
                { fixText ? <Button onClick={this.fixShortCourseS3Paths}>{fixText}</Button> : null }
                <SortableTableClassic
                    title="Scan Results"
                    hideFilter
                    rows={this.state.scanResults}
                    uniqueRowKey="index"
                    columns={
                        [
                        {
                            displayName: 'Project',
                            key:'project_name',
                            size: 5,
                            type: 'int',
                        },
                        {
                            displayName: 'Short Course',
                            key:'course_title',
                            size: 5,
                            type: 'int',
                        },
                        {
                            displayName: 'Archived',
                            key:'archived',
                            size: 1,
                            type: 'bool',
                        },
                        
                        {
                            displayName: 'Version',
                            key:'version',
                            size: 1,
                            type: 'int',
                        },
                        {
                            displayName: 'Node',
                            key:'node_name',
                            size: 3,
                            type: 'int',
                        },
                        {
                            displayName: "Column", 
                            key: 'column',
                            size: 2,
                            type: 'string',
                        },
                        {
                            displayName: 'Select for fixing',
                            key:'selected',
                            size: 1,
                            type: 'string',
                        },
                        ]
                    }
                    
                    displayColumnCallbacksId={{
                        selected:(index) => {
                            let entry = this.state.scanResults[Number(index)];
                            let checked = entry ? entry.selected : false;
                            if (!entry) {
                                console.log(`no selection for index ${typeof index} ${index}`,this.state.scanResults);
                            }
                            return (
                                <input type="checkbox" checked={checked} disabled={entry ? false : true} onChange={this.onScanResultsSelect.bind(this,index)}/>
                            );
                        }
                    }}
                    
                />
            </div>
        );
    } // renderScanResults
    
    render() {
        if (!this.state.registrationTokenStoreState.initialized) {
            return <LoadingMainContent />;
        }

        return (
            <div>
                <AdminSiteConfigEditor />
                <SiteFeaturesEditor className="margin-top-lg margin-bottom-lg" />
                
                {this.renderProviderSection()}
                
                <h2 className="heading-lg">Registration Tokens</h2>
                {sortBy(this.state.registrationTokenStoreState.tokens, 'id').map(token => 
                    <RegTokenProjectListing token={token} key={token.id} />
                )}

                <ExpandableWell title="Elevenlabs Voices">
                    <AdminVoiceEnableDisablePanel engine='elevenlabs'/>
                </ExpandableWell>
                <ExpandableWell title="Cartesia Voices">
                    <AdminVoiceEnableDisablePanel engine='cartesia'/>
                </ExpandableWell>
                <h2 className="heading-lg">Maintenance</h2>
                <Button disabled={this.state.scanning} onClick={this.scanShortCoursesForS3Paths}>{'Scan Short Courses for Hardcoded S3 Paths'}</Button>
                {this.renderScanResults()}
            </div>
        );
    }
}

AdminSiteConfigView.propTypes = propTypes;
AdminSiteConfigView.defaultProps = defaultProps;

export default AdminSiteConfigView;
